import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePricingPlan } from '../../hooks/usePricingPlan';
import SubscriptionsAPI from '../../api/SubscriptionsAPI';
import { isSubscriptionPaymentFailed } from '../../utils/subscriptionStatusMapper';

export const SubscriptionPaymentFailedBanner: React.FC = () => {
  const { t } = useTranslation();
  const { currentSubscription, isLoggedIn, isLoadingSubscription } = usePricingPlan();

  const isPaymentFailed =
    isLoggedIn &&
    !isLoadingSubscription &&
    isSubscriptionPaymentFailed(currentSubscription?.status);

  const handleResolvePayment = async () => {
    try {
      const response = await SubscriptionsAPI.createCheckoutOrPortal('current');
      if (response.data?.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error('Failed to open subscription portal:', error);
    }
  };

  if (!isPaymentFailed) {
    return null;
  }

  return (
    <div className="sticky top-0 z-10 w-full border-b border-red-300 bg-red-600 text-white shadow-sm">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm font-medium text-red-50">
          {t(
            'subscription.payment_failed_banner',
            'Your subscription payment could not be processed. Check funds in your account, update your card, or take action in the link below.'
          )}
        </p>
        <button
          type="button"
          onClick={handleResolvePayment}
          className="shrink-0 rounded-md border border-white/80 bg-white px-4 py-2 text-sm font-medium text-red-700 transition-colors hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-red-600"
        >
          {t('subscription.payment_failed_cta', 'Resolve payment')}
        </button>
      </div>
    </div>
  );
};
